import React from 'react';
import ModuleTopic from '../../components/ModuleTopic';

interface ITopicProps {
  settings: any;
}

const TopicIncident: React.FunctionComponent<ITopicProps> = ({ settings }) => (
  <ModuleTopic settings={settings} moduleKey="incident" />
);

export default TopicIncident;
